// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PageTitle_wrap__qZp6v","title":"PageTitle_title__2qx5v","subTitle":"PageTitle_subTitle__16bD7","backButton":"PageTitle_backButton__1AUL1"};